import React from 'react'
import mirador from 'mirador'
import CanvasAnnotations from 'mirador/dist/es/src/containers/CanvasAnnotations'
import CompanionWindow from 'mirador/dist/es/src/containers/CompanionWindow'
import ns from 'mirador/dist/es/src/config/css-ns'

interface IProps {
  targetProps?: {
    id: string
    canvasIds: string[]
    t: (arg0: string) => string
    windowId: string
  }
  targetedAnnotations?: ITargetedAnnos[]
}

interface ITargetedAnnos {
  resources: {
    resource: {
      body: {
        value: string
      }[]
    }
  }[]
}

const SideBarWrapper: React.FC<IProps> = ({
  targetedAnnotations,
  targetProps,
}) => {
  // Filter out targeted annotations that do not have the tag for this sidebar
  const filteredAnnotations = targetedAnnotations?.filter((anno) =>
    anno.resources.some(
      (res) => res.resource.body[1].value === targetProps?.id,
    ),
  )

  if (targetProps === undefined || filteredAnnotations?.length === 0) {
    return <div />
  }

  const { id, canvasIds, t, windowId } = targetProps
  return (
    <CompanionWindow
      title={t('annotations')}
      paperClassName={ns('window-sidebar-annotation-panel')}
      windowId={windowId}
      id={id}
    >
      {canvasIds.map((canvasId: string, index: number) => (
        <CanvasAnnotations
          canvasId={canvasId}
          key={canvasId}
          index={index}
          totalSize={canvasIds.length}
          windowId={windowId}
          tagId={id}
        />
      ))}
    </CompanionWindow>
  )
}

const mapStateToProps = (
  state: never,
  { windowId }: { windowId: string },
): { targetedAnnotations: ITargetedAnnos[] } => ({
  targetedAnnotations: mirador.selectors.getSelectedAnnotationsOnCanvases(
    state,
    { windowId },
  ),
})

const exportedObject = {
  name: 'SideBarWrapper',
  target: 'WindowSideBarAnnotationsPanel',
  mode: 'wrap',
  component: SideBarWrapper,
  mapStateToProps,
}
export default exportedObject
